import { successToast } from "./toast";
export default function copyToClipboard(text, t) {
  if (t) {
    successToast({
      t,
      title: t('label_success'),
      text: t('label_copied_to_clipboard')
    });
  }
  return navigator.clipboard.writeText(text);
}